// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__71Cgp","card":"style_card__vX2Q+"};